import { gql } from "@apollo/client";
import { useQuery } from "react-query";
import { useAuth } from "../contexts/auth";

export const queryKey = "useTenantPaymentsClosed";

type Result = {
  tenantPaymentsClosed: boolean;
  tenantPaymentsClosedMessage: string;
};

const query = gql`
  query GetTenantPaymentsClosed {
    tenantPaymentsClosed
    tenantPaymentsClosedMessage
  }
`;

// Public on the server: the answer is the same for every tenant.
/**
 * Whether Doorstead has stopped taking tenant payments (server-decided, by
 * date). While loading it reads as open: the server refuses every payment
 * after the cutoff regardless, so this only decides what the portal shows.
 */
export function useTenantPaymentsClosed(): { closed: boolean; message: string } {
  const { gqlClient } = useAuth();
  const { data } = useQuery<unknown, unknown, Result>(
    queryKey,
    async () => await gqlClient.query({ query }).then((e) => e.data),
    { staleTime: 5 * 60 * 1000 }
  );
  return {
    closed: Boolean(data?.tenantPaymentsClosed),
    message: data?.tenantPaymentsClosedMessage || "",
  };
}
